<script setup>
defineProps({
  payment: {
    type: Object,
    required: true,
  },
});

const statusText = (status) => {
  const map = {
    completed: "รับชำระสมบูรณ์",
    partial: "ชำระบางส่วน",
    pending_verify: "รอตรวจสอบ",
  };
  return map[status] || status;
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลผู้ชำระ / ยูนิต</h5>
          <div class="text-muted small">
            ข้อมูลลูกบ้านและหน่วยที่เกี่ยวข้องกับรายการนี้
          </div>
        </div>
        <div class="payer-avatar">
          <i class="bi bi-person-vcard"></i>
        </div>
      </div>

      <div class="mb-4">
        <div class="fw-bold fs-5">{{ payment.residentName }}</div>
        <div class="text-muted">
          ยูนิต {{ payment.unitCode }} • {{ payment.building }}
        </div>
      </div>

      <div class="vstack gap-3">
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">เลขที่ใบแจ้งหนี้</span>
          <span class="fw-semibold">{{ payment.invoiceNo }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">เลขที่รับชำระ</span>
          <span class="fw-semibold">{{ payment.paymentNo }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">สถานะ</span>
          <span class="fw-semibold">{{ statusText(payment.status) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.payer-avatar {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}
</style>
